module.exports = __webpack_public_path__ + "images/emoji/pizza.9c4689eb6a21e2e5022a.png";